module.exports = __webpack_public_path__ + "img/155.9a23ed6f.jpg";